export const MapTileService = Symbol('MapTileService');
export interface MapTileService {
  buildLeafletTileUrl(): string;
  buildOptions(): Record<string, unknown>;
}
